import React, { useMemo, useState } from 'react'
import { CONTROL_STATUS } from '@trustero/trustero-api-web/lib/model/control_pb'
import { BasicDropdown } from 'src/components/Reusable/BasicDropdown/BasicDropdown'
import {
  BASIC_DROPDOWN_ALIGN,
  BASIC_DROPDOWN_DROP,
} from 'src/components/Reusable/BasicDropdown/BasicDropdown.constants'
import { useBasicDropdown } from 'src/components/Reusable/BasicDropdown/context/BasicDropdownContext'
import { BasicDropdownItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.types'
import isFunction from 'lodash/isFunction'
import {
  ControlStatusDropdownOptions,
  ControlStatusOptions,
} from './Dropdowns.constants'

export const ControlStatusDropdown = ({
  id,
  initialStatus,
  onSelect,
  isDisabled,
}: {
  id: string
  initialStatus: CONTROL_STATUS
  onSelect?: (status: CONTROL_STATUS) => void
  isDisabled?: boolean
}): JSX.Element => {
  const { openDropdownId, setOpenDropdownId } = useBasicDropdown()
  const dropdownId = `control-status-${id}`
  const isOpen = openDropdownId === dropdownId

  const [selectedItem, setSelectedItem] = useState<BasicDropdownItem>({
    name: ControlStatusOptions[initialStatus as CONTROL_STATUS],
    value: initialStatus,
  })
  const items = useMemo(
    () =>
      ControlStatusDropdownOptions.filter(
        (option) => option.key !== CONTROL_STATUS.NOTAPPLICABLE,
      ).map(
        (option) =>
          ({
            name: option.label,
            value: option.key,
          } as BasicDropdownItem),
      ),
    [],
  )

  const updateStatus = async (item: BasicDropdownItem) => {
    setSelectedItem(item)
    if (isFunction(onSelect)) {
      onSelect(item.value as CONTROL_STATUS)
    }
  }

  const handleToggle = (isOpen: boolean) => {
    if (isOpen) {
      setOpenDropdownId(dropdownId)
    } else {
      setOpenDropdownId(null)
    }
  }

  return (
    <BasicDropdown
      selectedItem={selectedItem}
      items={items}
      onSelect={updateStatus}
      drop={BASIC_DROPDOWN_DROP.DOWN}
      align={BASIC_DROPDOWN_ALIGN.END}
      backgroundColor={
        ControlStatusDropdownOptions.find(
          (option) => option.key === selectedItem.value,
        )?.colors.background
      }
      borderColor={
        ControlStatusDropdownOptions.find(
          (option) => option.key === selectedItem.value,
        )?.colors.border
      }
      onToggle={handleToggle}
      show={isOpen}
      offset={4}
      disabled={
        isDisabled || selectedItem.value === CONTROL_STATUS.NOTAPPLICABLE
      }
    />
  )
}
